<template>
  <IQOS required>
    <template #title>
      <div class="pos-title">
        <img
          :src="currentPosImage"
          class="pos-title-image"
        />
        {{ $t("integrations.pos_product_link.title") }}
      </div>
    </template>

    <div v-if="hasPosterIntegration && !hasPosterPriceGroups">
      <PosterMenuInput
        class="mt-16"
        @setData="setDishPosterData"
        @reset="emitUpdate"
        v-model="dish.poster_product_id"
      />
      <BaseSelect
        class="w-100 mt-16"
        fullWidth
        v-model="productPosterModificationId"
        selectId="poster-modification-attachment"
        v-if="posterProductModifications.length"
      >
        <option :value="null">
          {{ $t("integrations.poster_menu_input.modificator_input_none") }}
        </option>
        <option
          v-for="(item, index) in posterProductModifications"
          :key="index"
          :value="item.poster_modification_id"
        >
          {{ $t("integrations.poster_menu_input.modificator_input_prefix") }}
          "{{ item.name }}"
        </option>
      </BaseSelect>
    </div>
    <div v-if="hasIikoIntegration">
      <IikoMenuInput
        class="mt-16"
        @setData="setDishIikoData"
        v-model="dish.iiko_product_id"
      />
    </div>
    <p
      class="iqos-comment qrw-paragraph-md mt-16"
      v-if="!hasPosterPriceGroups"
    >
      {{ $t("integrations.pos_product_link.desc") }}
    </p>

    <p
      class="iqos-comment qrw-paragraph-md orange-4-color"
      v-if="hasPosterPriceGroups"
    >
      {{ $t("integrations.pos_product_link.has_variants") }}
    </p>
  </IQOS>
</template>

<script>
import PosterMenuInput from '@/components/integrations/PosterMenuInput.vue'
import IikoMenuInput from '@/components/integrations/IikoMenuInput.vue'

export default {
  components: {
    PosterMenuInput,
    IikoMenuInput
  },
  watch: {
    productPosterModificationId(value, oldValue) {
      if (value !== oldValue) {
        this.$forceUpdate()
        document.querySelector('#poster-modification-attachment').dispatchEvent(new Event('change'))

        console.log(`forcing update`)
      }
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update')
    },
    setDishPosterData(item) {
      if (!this.dishName) {
        this.dishName = item.name
      }

      this.$store.commit('menu/makeProductForceModified')

      this.dishWeightFlag = item.weight_flag || 0
      if (!this.dish.image && item.image)
        this.$store.commit('menu/setProductData', {
          key: 'image',
          value: item.image
        })
      this.$store.commit('menu/setProductData', {
        key: 'price_groups',
        value: item.price_groups
      })
      const pg_i18ns = item.price_groups.map(group => {
        return {
          name: null,
          items: group.items.map(i => null)
        }
      })

      for (const locale of this.$store.state.menu.current.locales) {
        const loc = this.dish.i18n.find(l => l.locale == locale)

        if (loc) {
          loc.price_groups = pg_i18ns
        } else {
          this.dish.i18n.push({
            locale,
            pg_i18ns,
            name: null,
            description: null
          })
        }
      }
      this.$store.commit('menu/setProductData', {
        key: 'poster_modification_id',
        value: null
      })
      this.$store.commit('menu/setProductData', {
        key: 'base_price',
        value: item.base_price
      })
      this.emitUpdate()

      this.$store.dispatch('auditlog/write', {
        type: 'change_menu_product_integration',
        payload: {
          platform: 'poster',
          dish_name: this.dish.name,
          dish_id: this.dish._id,
          poster_id: this.dish.poster_id,
          poster_name: item.name
        }
      })
    },
    setDishIikoData(item) {
      if (!this.dishName) {
        this.dishName = item.name
      }

      const fixed_price_groups = item.price_groups.slice()

      fixed_price_groups.map(pg => {
        pg.items.forEach(pgitem => {
          pgitem.stock = true
        })
      })

      if (item.image) {
        if (!this.dish.image || !this.dish.image.includes('cdn.qrwaiter.com.ua'))
          this.$store.commit('menu/setProductData', {
            key: 'image',
            value: item.image
          })
      }

      this.$store.commit('menu/setProductData', {
        key: 'price_groups',
        value: fixed_price_groups
      })
      this.$store.commit('menu/setProductData', {
        key: 'base_price',
        value: item.price
      })
      this.$store.commit('menu/setProductData', {
        key: 'external_weighted_price',
        value: item.price
      })
      this.emitUpdate()

      this.$store.dispatch('auditlog/write', {
        type: 'change_menu_product_integration',
        payload: {
          platform: 'iiko',
          dish_name: this.dish.name,
          dish_id: this.dish._id,
          iiko_id: this.item.iiko_id
        }
      })
    }
  },
  computed: {
    dishName: {
      get() {
        return this.dish.name
      },
      set(value) {
        this.$store.commit('menu/setProductData', {
          key: 'name',
          value
        })
      }
    },
    hasPosterIntegration() {
      return this.$store.getters.hasPosterIntegration
    },
    hasIikoIntegration() {
      return this.$store.getters.hasIikoIntegration
    },
    dish() {
      return this.$store.state.menu.product
    },
    posterProductModifications() {
      if (!this.hasPosterIntegration) return []
      if (!this.dish) return []
      if (!this.dish.poster_product_id) return []

      const poster_product = this.$store.getters['poster/findPosterProduct'](this.dish.poster_product_id)

      if (!poster_product) return []

      if (!poster_product.price_groups.length) return []

      const all_items = poster_product.price_groups.reduce((acc, gr) => acc.concat(gr.items), [])

      return all_items
    },
    productPosterModificationId: {
      get() {
        if (!this.dish) return null
        if (this.dish._id == null) return null
        console.log(`${this.dish.name} =>${this.dish.poster_modification_id}`)
        return this.dish.poster_modification_id
      },
      set(v) {
        const selected_modification = this.posterProductModifications.find(m => m.poster_modification_id == v) || {
          price: 0
        }

        this.$store.commit('menu/setProductData', {
          key: 'poster_modification_id',
          value: v
        })

        this.$store.commit('menu/setProductData', {
          key: 'base_price',
          value: Math.round(this.dish.base_price + selected_modification.price)
        })

        if (!!v)
          this.$store.commit('menu/setProductData', {
            key: 'price_groups',
            value: []
          })
        this.emitUpdate()
      }
    },
    hasPosterPriceGroups() {
      // return !!this.dish.price_groups.find((g) => {
      //   if (!g.single_select) return false;
      //   return !!g.items.find((i) => !!i.poster_product_id);
      // });
      return false
    },
    currentPosImage() {
      if (this.hasPosterIntegration) {
        return '/icons/poster-integration.png'
      }

      if (this.hasIikoIntegration) {
        return '/icons/iiko.png'
      }

      return ''
    }
  }
}
</script>

<style scoped>
.pos-title-image {
  width: 24px;
  height: 24px;
  max-height: 24px;
  min-width: 24px;
  max-width: 24px;

  margin-right: 8px;
  border-radius: 4px;
}

.pos-title {
  display: flex;
  align-content: center;
  align-items: center;
}
</style>